import { SUPERUSER_ROLES } from "../utils/roles";

// Niveles de acceso especiales (además de una lista explícita de roles):
export const PUBLIC = "PUBLIC"; // sin restricción (páginas libres)
export const AUTH = "AUTH"; //   cualquier usuario autenticado

// Mapa vista(routeId) -> acceso, derivado de nova_vistas_roles_privilegios.xlsx
// (filas de Floorapp). Los ids coinciden con routeList.js / menuItemFilter.
//
// ⚠️ Los strings de rol son los CANÓNICOS del JWT de Nova Engine.
//    Vistas ausentes del mapa quedan sin restricción de rol (solo su flag).
export const viewPermissions = {
    home: ["Administrador", "Supervisor", "Calidad", "Operador"],
    paros: ["Administrador", "Supervisor", "Operador"],
    celdas: AUTH,
    calidad: ["Administrador", "Calidad"],
    tv: PUBLIC,
    "build-info": PUBLIC,
    // Config de estación (no es una ruta del menú): acción sensible, solo Admin.
    // Ojo: se valida aparte en Login (sin superusuario 'Consulta').
    "config-estacion": ["Administrador"],
};

// ¿El conjunto de roles del usuario puede acceder a la vista viewId?
export function canAccessView(viewId, roles = []) {
    const rule = viewPermissions[viewId];
    if (rule === undefined) return true; // no listada -> solo la gobierna el flag
    if (rule === PUBLIC || rule === AUTH) return true; // basta con estar autenticado
    if (roles.some((r) => SUPERUSER_ROLES.includes(r))) return true; // superusuarios ven todo
    return roles.some((r) => rule.includes(r));
}
